import React from "react";
import styled from "styled-components";
import { TextArea } from "@sonder/ui/source/styled/fragments/TextArea";
import { colors } from "@sonder/ui/source/styled/theme";
import { ParsedText } from "tasks/components/ParsedText";

const StyledTextArea = styled(TextArea)`
  background: none;
  border: none;
  caret-color: ${colors.gray1};
  color: transparent;
  padding: 0;
  width: 100%;
`;

const TemporaryPlaceholder = styled.div`
  color: ${colors.gray6};
`;

export interface ParsedTextWrapperProps {
  disabled?: boolean;
}

const ParsedTextWrapper = styled.div<ParsedTextWrapperProps>`
  cursor: ${props => (props.disabled ? "not-allowed" : "inherit")};
  color: ${colors.gray1};
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
`;

const EditableTextWrapper = styled.div`
  position: relative;

  textarea {
    overflow: hidden;
  }

  ${ParsedTextWrapper} {
    pointer-events: none;
    position: absolute;
    top: 0;

    a {
      pointer-events: all;
    }
  }
`;
interface EditableTextProps {
  disabled?: boolean;
  onChange?: (text: string) => void;
  placeholder?: string;
  value?: string;
}

export const EditableText = ({
  disabled = false,
  onChange,
  placeholder = "Enter notes here",
  value,
}: EditableTextProps) => {
  const isTextEmpty = value?.trim() === "";
  return (
    <EditableTextWrapper>
      <ParsedTextWrapper disabled={disabled}>
        {isTextEmpty ? (
          <TemporaryPlaceholder>{placeholder}</TemporaryPlaceholder>
        ) : (
          <ParsedText>{value}</ParsedText>
        )}
      </ParsedTextWrapper>
      <StyledTextArea
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          if (onChange) {
            onChange(e.target.value);
          }
        }}
      />
    </EditableTextWrapper>
  );
};
